// App Registry - Central configuration for all micro apps
import ExpenseTracker from '../apps/expenses/ExpenseTracker';
import ChoreApp from '../apps/chores/ChoreApp';
import StrengthApp from '../apps/strength/StrengthApp';
import CompensationApp from '../apps/compensation/CompensationApp';
import PropertyManager from '../components/PropertyManager';
import HouseholdCosts from '../apps/household-costs/HouseholdCosts';
import HouseholdManager from '../components/HouseholdManager';
import GrapeEscape from '../apps/grape-escape/GrapeEscape';
import BookClubApp from '../apps/bookclub/BookClubApp';
import TravelApp from '../apps/travel/TravelApp';
import SaxTutorApp from '../apps/saxtutor/SaxTutorApp';
import FlightFinder from '../apps/flights/FlightFinder';
import UserAdmin from '../apps/admin/UserAdmin';
import Profile from '../apps/admin/Profile';

export const appRegistry = [
  {
    id: 'expenses',
    name: 'Expense Tracker',
    description: 'Upload credit card statements, categorize expenses, and track household spending with your partner.',
    icon: '🧾',
    route: '/expenses',
    component: ExpenseTracker,
    external: false,
    requiresAuth: true,
    status: 'active'
  },
  {
    id: 'properties',
    name: 'Property Portfolio',
    description: 'Track your real estate investments, monitor property values, and analyze your portfolio performance over time.',
    icon: '🏘️',
    route: '/properties',
    component: PropertyManager,
    external: false,
    requiresAuth: true,
    status: 'active'
  },
  {
    id: 'household-costs',
    name: 'Household Costs',
    description: 'Split every property and household cost between you — by ownership, by loan share, evenly or directly — and see who owes whom each month.',
    icon: '🏦',
    route: '/household-costs',
    component: HouseholdCosts,
    external: false,
    requiresAuth: true,
    status: 'active'
  },
  {
    id: 'chores',
    name: 'Household Chores',
    description: 'Track and manage household chores with your family. Plan, claim, and complete tasks together.',
    icon: '🧹',
    route: '/chores',
    component: ChoreApp,
    external: false,
    requiresAuth: true,
    status: 'active'
  },
  {
    id: 'strength',
    name: 'Strength Training',
    description: 'Let the AI coach build your plan, log every set, track your progress — and upload each workout to Strava automatically.',
    icon: '🏋️',
    route: '/strength',
    component: StrengthApp,
    external: false,
    requiresAuth: true,
    status: 'active'
  },
  {
    id: 'compensation',
    name: 'Compensation',
    description: 'Track your Microsoft compensation — base salary, bonuses, stock vesting, ESPP, and live stock prices.',
    icon: '💰',
    route: '/compensation',
    component: CompensationApp,
    external: false,
    requiresAuth: true,
    status: 'active'
  },
  {
    id: 'grape-escape',
    name: 'Grape Escape',
    description: 'Wine tasting, cellar management & community',
    icon: '🍇',
    route: '/grape-escape',
    component: GrapeEscape,
    external: false,
    requiresAuth: true,
    status: 'active'
  },
  {
    id: 'bookclub',
    name: 'Book Club',
    description: 'Discover books, join clubs, track your reading journey',
    icon: '📚',
    route: '/bookclub',
    component: BookClubApp,
    external: false,
    requiresAuth: true,
    status: 'active'
  },
  {
    id: 'travel',
    name: 'Travel Planner',
    description: 'Plan trips with packing lists, flight details, accommodations, itineraries, budgets, and more.',
    icon: '✈️',
    route: '/travel',
    component: TravelApp,
    external: false,
    requiresAuth: true,
    status: 'active'
  },
  {
    id: 'saxtutor',
    name: 'SaxTutor',
    description: 'Upload sheet music and learn saxophone with animated fingering charts and audio playback.',
    icon: '🎷',
    route: '/saxtutor',
    component: SaxTutorApp,
    external: false,
    requiresAuth: true,
    status: 'active'
  },
  {
    id: 'flights',
    name: 'Flight Finder',
    description: 'Search SAS.no for the best flight deals across flexible dates with calendar and list views.',
    icon: '✈️',
    route: '/flights',
    component: FlightFinder,
    external: false,
    requiresAuth: true,
    status: 'active'
  },
];

// Household Groups — treated as a settings/utility, not a micro-app
export const utilityApps = [
  {
    id: 'household-groups',
    name: 'Household Groups',
    description: 'Manage who you share data with — invite family members to see each other\'s properties and finances.',
    icon: '👨‍👩‍👧‍👦',
    route: '/household-groups',
    component: HouseholdManager,
    requiresAuth: true
  },
  {
    id: 'users',
    name: 'Registered Users',
    description: 'See who has signed up to Kosmoholm.',
    icon: '👥',
    route: '/users',
    component: UserAdmin,
    requiresAuth: true
  },
  {
    id: 'profile',
    name: 'Your Profile',
    description: 'Update your display name and profile settings.',
    icon: '👤',
    route: '/profile',
    component: Profile,
    requiresAuth: true
  }
];

// Helper functions
export const getAppById = (id) => [...appRegistry, ...utilityApps].find(app => app.id === id);
export const getActiveApps = () => appRegistry.filter(app => app.status === 'active');
export const getInternalApps = () => [...appRegistry, ...utilityApps].filter(app => !app.external && app.component);
export const getAllApps = () => [...appRegistry, ...utilityApps];